import React from "react";
import { Link } from "react-router-dom";

const NotFound = ({ text = "Page not found" }) => {
  return (
    <div className="container text-center" style={{ marginTop: "150px", marginBottom: "100px" }}>
      <h2>{text}</h2>
      <p>
        <Link to="/">Go to the homepage</Link>
      </p>
    </div>
  );
};

export default NotFound;
